// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-13d39fab] {\n  display: flex;\n}\n[data-v-13d39fab] .el-form-item__content {\n  flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
